"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { sortingSchema } from "./sorting-schema";
export const ProductGridSorting = t0 => {
  const $ = _c(10);
  const {
    sorting
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const sortingLiteral = sorting ? `${sorting[0]}|${sorting[1]}` : undefined;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "Price from low to high",
      value: "price|asc"
    }, {
      label: "Price from high to low",
      value: "price|desc"
    }, {
      label: "Name ascending",
      value: "name|asc"
    }, {
      label: "Name descending",
      value: "name|desc"
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const sortingOptions = t1;
  let t2;
  if ($[1] !== pathname || $[2] !== router || $[3] !== searchParams) {
    t2 = value => {
      const sorting_0 = sortingSchema.safeParse(value.split("|"));
      if (sorting_0.data) {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set("orderBy", sorting_0.data[0]);
        newSearchParams.set("order", sorting_0.data[1]);
        router.push(pathname + "?" + newSearchParams);
      }
    };
    $[1] = pathname;
    $[2] = router;
    $[3] = searchParams;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectTrigger className="w-full max-w-52"><SelectValue placeholder="Sort products" /></SelectTrigger>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SelectContent>{sortingOptions.map(_temp)}</SelectContent>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== sortingLiteral || $[8] !== t2) {
    t5 = <div className="flex justify-end mb-2"><Select defaultValue={sortingLiteral} onValueChange={t2}>{t3}{t4}</Select></div>;
    $[7] = sortingLiteral;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp(option) {
  return <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>;
}